export default "__VITE_ASSET__22a9409b__"